import { gql } from '@apollo/client'

export const MENU_MODIFIER_FRAGMENT = gql`
  fragment MenuModifier on MenuModifier {
    description
    id
    name
  }
`
